
<h1 style="text-align:center;"></h1>

<ngb-carousel timings="250ms ease-in" [showNavigationArrows]="true"
              [showNavigationIndicators]="true"
              [keyboard]="true"
              [pauseOnHover]="true"
              [wrap]="true"
              [activeId]="'sliderOne'">

  <!--<ng-template ngbSlide id="sliderOne">
    <div class="top-content">
      <div class="container-fluid">
        <div class="row mobile-view">
          <div class="col justify-content-center m-0 p-0">
            <img src="../../../../assets/Images/iripash.png">

          </div>

        </div>
      </div>
     
    </div>

  </ng-template>-->



  <ng-template ngbSlide id="sliderOne">
    <div class="top-content">
      <div class="container-fluid">
        <div class="row mobile-view">
          <div class="col justify-content-center m-0 p-0">
            <img src="assets/Images/1.png">

          </div>

        </div>
      </div>
      <div class="banner_content">

        <div class="home-dtl" >
          <div class="home-heading">Learn Anytime</div>
          <div class="home-heading">Learn Wherever, Whenever, However...</div>
          <div class="home-heading">
            Online classes
          </div>
        </div>
      </div>
    </div>

  </ng-template>
  <ng-template ngbSlide id="sliderTwo">
    <div class="top-content">
      <div class="container-fluid">
        <div class="row mobile-view">
          <div class="col justify-content-center m-0 p-0">
            <img src="assets/Images/2.png">

          </div>

        </div>
      </div>
      <div class="banner_content">

        <div class="home-dtl">
          <div class="home-heading">Learn Smart Online</div>
          <div class="home-heading">
            Become a better researcher
          </div>
          <div class="home-heading">
            Online classes
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template ngbSlide id="sliderThree">
    <div class="top-content">
      <div class="container-fluid">
        <div class="row mobile-view">
          <div class="col justify-content-center m-0 p-0">
            <img src="assets/Images/3.png">

          </div>

        </div>
      </div>
      <div class="banner_content">
        <div class="home-dtl">
          <div class="home-heading">Online Courses</div>
          <div class="home-heading">
            Explore a variety of fresh topics
          </div>
          <div class="home-heading">
            Search Online.. Explore Online
          </div>
        </div>
      </div>
    </div>

  </ng-template>

</ngb-carousel>

<!-- <div class="container" style="    background-color: rgb(5, 5, 104);    color: wheat;">
  <div class="row">
    <div class="col-lg-4 col-md-4">
      <div class="learning-work-block">
        <div class="row">
          <div class="col-lg-3 col-md-3">
            <div class="learning-work-icon">
              <i class="fa fa-anchor"></i>
            </div>
          </div>
          <div class="col-lg-9 col-md-9">
            <div class="learning-work-dtl">
              <div class="work-heading">Learn Anytime, Anywhere</div>
              <p>Online Courses for Creative</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4">
      <div class="learning-work-block">
        <div class="row">
          <div class="col-lg-3 col-md-3">
            <div class="learning-work-icon">
              <i class="fa fa-magic"></i>
            </div>
          </div>
          <div class="col-lg-9 col-md-9">
            <div class="learning-work-dtl">
              <div class="work-heading">Beacome a researcher</div>
              <p>Improve Your Skills Online</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4">
      <div class="learning-work-block">
        <div class="row">
          <div class="col-lg-3 col-md-3">
            <div class="learning-work-icon">
              <i class="fa fa-graduation-cap"></i>
            </div>
          </div>
          <div class="col-lg-9 col-md-9">
            <div class="learning-work-dtl">
              <div class="work-heading">Most Popular Courses</div>
              <p>Learn on your schedule</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

